<template>
  <div>
   <div class="container flash-message-top-container">
      <flash-message class="flash-message-top"></flash-message>
    </div>    
    <div class="container container-admin text-center">
      <h3>{{title}}</h3>
      <div class="form-group row">        
        <div class="col-md-6 label-left">
          <Language />   
        </div>
        </div>
        <div class="form-group row">       
        <div class="col-md-6 label-left d-flex">
          <div class="w-100">
            <label class="requered" for="menuList">Menu list</label>
            <select class="form-control" v-validate="'required'" name="menuList" aria-describedby="selectMenuList" @change="changeMenu($event)">
              <option v-for="menuL in menuList" v-bind:key="menuL._id" :value="menuL._id">{{menuL.name}}</option>
            </select>
            <span class="span-valid-text" v-show="errors.has('menuList')" >{{ errors.first('menuList') }} </span> 
          </div>
          <div>
            <button type="button" class="btn btn-link" id="btnRemoveMenu" title="remove menu"
              v-confirm="{ok: () => { removeMenu(); }, cancel: cancelRemove, message: 'Are you sure you want to remove menu item ?'}" 
            >
              <i class="fa fa-trash button-icon"></i>
            </button> 
          </div>  
        </div>        
        <div class="col-md-6 label-left d-flex">
          <div class="w-100">
            <label class="requered" for="newMenu">New Menu</label>
            <input type="text" class="form-control" id="newMenu" v-validate="'required'" aria-describedby="newMenu" placeholder="New Menu" v-model="menu.name">
            <span class="span-valid-text" v-show="errors.has('newMenu')" >{{ errors.first('newMenu') }} </span>
          </div>
          <div>
            <button type="button" class="btn btn-link" id="btnAddMenu" title="add menu" @click="addNewMenu()">
              <i class="fa fa-plus-square button-icon"></i>
            </button>
          </div> 
        </div>
         
        </div>
        <div class="form-group row">
          <div class="col-md-4 label-left">
           <label class="requered" for="type">Type</label>
           <select class="form-control" v-validate="'required'" id="type" aria-describedby="selectType"  @change="($event) => {changeItemType($event)}">
             <option disabled selected>Menu Type</option>
             <option>Article</option>
             <option>Category</option>
             <option>Link</option>
           </select>
           <span class="span-valid-text" v-show="errors.has('language')" >{{ errors.first('language') }} </span>   
        </div>
        <div class="col-md-4 label-left" v-if="menuItem.type === 'Article' || menuItem.type === 'Category'">
           <label class="requered" :for="menuItem.type">{{menuItem.type}}</label>
           <select class="form-control" v-validate="'required'" :id="menuItem.type" aria-describedby="selectArticle"  @change="changeTypeItemCategory($event)">
             <option>select item</option>
             <option value='all'>All categories</option>
             <option v-for="tItem in typeItems" v-bind:key="tItem._id" :value="tItem._id">{{tItem.title}}</option>
           </select>
           <span class="span-valid-text" v-show="errors.has(menuItem.type)" >{{ errors.first(menuItem.type) }} </span>   
        </div>        
        <div class="col-md-4 label-left" v-if="menuItem.type === 'Link'">
            <label class="requered" for="itemLink">Link</label>
            <input type="text" class="form-control" id="itemLink" v-validate="'required'" aria-describedby="itemLink" placeholder="Item Link" @change="changeTypeItemLink($event)" >    
            <span class="span-valid-text" v-show="errors.has('itemLink')" >{{ errors.first('itemLink') }} </span>
        </div>            
        <div class="col-md-4 label-left" v-if="menuItem.type !== ''">
          <label class="requered" for="newItem">New item title</label>
          <input type="text" class="form-control" id="newItem" v-validate="'required'" aria-describedby="newItem" placeholder="New Item Title" v-model="menuItem.title">    
          <span class="span-valid-text" v-show="errors.has('newItem')" >{{ errors.first('newItem') }} </span>
        </div>            
        </div>
        <div class="form-group row">
          <div class="col-md-2 label-left">
            <a href="#" class="btn btn-primary" @click="addNewMenuItem()">Add</a>
           </div>
        </div>
        <div class="form-group row">
            <div class="col-md-6 label-left">
                <ul class="list-group menu-item-ul">
                  <li class="list-group-item disabled active" aria-disabled="true">Menu Items</li>                  
                  <li v-for="iMenu in menuItems" v-bind:key="iMenu._id" class="list-group-item menu-item-li">
                    <span>{{iMenu.title}}</span>
                    <div class="d-flex">                    
                      <div class="div-admin-menu-up-down-container">
                        <button class="btn btn-link list-row-btn btn-admin-menu-up-down" @click="($event) => { moveMenuItemUp($event, iMenu.position, 'up') }">
                          <i class="fa fa-caret-up button-icon"></i>
                        </button>
                        <button class="btn btn-link list-row-btn btn-admin-menu-up-down" @click="($event) => { moveMenuItemUp($event, iMenu.position, 'down') }">
                          <i class="fa fa-caret-down button-icon"></i>
                        </button>
                      </div>
                      <button type="button" class="btn btn-link list-row-btn"
                        v-confirm="{ok: () => { removeMenuItem(iMenu._id); }, cancel: cancelRemove, message: 'Are you sure you want to remove menu item ?'}" 
                      >
                        <i class="fa fa-trash button-icon"></i>
                      </button>
                    </div>
                  </li>
                </ul>
            </div>
        </div>  
    </div>
  </div>
</template>

<script>
  import { getDataFromServerWithHeader, getDataFromServer } from '../../utils/DataProvider'
  import Language from "../partial/Language"
  export default {     
     data: () => {
      return{
         title: 'Menu',
         menu: {menu_id: 'main_menu', name: '', language: 'he_IL', menu_items: []},
         selectedMenu: '',
         language: '',
         menuList: [],
         menuItems: [],
         menuItem: {item_link: '', type: '', type_item_id: '', title: '', position: ''},
         typeItems: [],
         selectedTypeItem: '',
      }     
    },
    components: {       
       Language,
    },
    methods:{
      changeItemType(e){
         this.menuItem.type = e.target.value
         var url = e.target.value === 'Article' ? 'get_articles_bylanguage' : 'get_category_bylanguage';
         
         getDataFromServer(url, this.language)
        .then(obj => 
        {                  
          if(obj.data.success === true){              
            this.typeItems = obj.data.data                              
          }
          else{
            this.flash('get type items list error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {          
          this.flash('get ype items list error: ' + err, 'error', {timeout: 4000})
        })
      },
      
      changeLanguage(e){               
        this.language = e.target.value
        this.selectedMenu = ''
        this.getMenuList();
      },

      changeMenu(e){
        this.selectedMenu = e.target.value
        this.getMenuItemsByMenuId()
      },

      changeTypeItemCategory(e){
        console.log("selecter category id: ", e.target.value)
        this.selectedTypeItem = e.target.value
      },

      changeTypeItemLink(e){
        this.selectedTypeItem = e.target.value
      },

      addNewMenu(){
        this.menu.language = this.language
        this.menu.menu_id = this.menu.name + '_' + this.$uuid.v1()

        getDataFromServer('add_menu', this.menu)
        .then(obj => 
        {                  
          if(obj.data.success === true){                         
            this.getMenuList()
            this.flash('create menu success', 'success', {timeout: 4000})        
          }
          else{
            this.flash('get menu list error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {          
           this.flash('get menu list error: ' + err, 'error', {timeout: 4000})
        })
      },

      addNewMenuItem(){
        if(this.menuItem.type !== "Link"){
          let categoryId = this.selectedTypeItem !== 'all' ? '/' + this.selectedTypeItem : ''
          this.menuItem.item_link = '/' + this.menuItem.type.toLowerCase() + categoryId
        }else{
          this.menuItem.item_link = this.selectedTypeItem
        }      
        
        this.menuItem.type_item_id = this.selectedTypeItem
        this.menuItem.position = this.menuItems.length  === 0 ? 0 : this.menuItems.length -1;
        getDataFromServer('add_menu_item', {menu_id: this.selectedMenu, menu_item: this.menuItem})
        .then(obj => 
        {                  
          if(obj.data.success === true){                         
            this.getMenuList()            
            this.flash('create menu success', 'success', {timeout: 4000})        
          }
          else{
            this.flash('get menu list error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {          
           this.flash('get menu list error: ' + err, 'error', {timeout: 4000})
        })
      },

      getMenuList(){
        getDataFromServer('menu_list_by_language', {language: this.language})
        .then(obj => 
        {                 
          if(obj.data.success === true){                         
            this.menuList = obj.data.data
            this.selectedMenu = obj.data.data[0]._id
            this.getMenuItemsByMenuId()     
          }
          else{
            this.flash('get menu list error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {          
          this.flash('get menu list error: ' + err, 'error', {timeout: 4000})
        })
      },

      removeMenuItem(menuItemId){        
        getDataFromServer('remove_menu_item', {menu_id: this.selectedMenu, menu_item_id: menuItemId})
        .then(obj => 
        {                  
          if(obj.data.success === true){
            this.flash('remove menu item success' , 'success', {timeout: 4000})
            this.getMenuList()
          }
          else{
            this.flash('remove menu item error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {          
           this.flash('get menu list error: ' + err, 'error', {timeout: 4000})
        })
      },

      cancelRemove(){
          this.flash('cancel remove menu item', 'success', {timeout: 4000})
      },

      getMenuItemsByMenuId(){                       
        this.menuList.map((m) => {          
          if(m._id === this.selectedMenu){              
            this.menuItems = m.menu_items
          }
        })       
      },

      removeMenu(){
        //check system menu
        let isSystem = false
        this.menuList.forEach((menu) => {
          if(menu._id === this.selectedMenu && menu.menu_id === "main_menu"){
            isSystem = true
          }
        })
        
        //if menu system return warning message
        if(isSystem){
          this.flash('The main menu cant delete from system!', 'warning', {timeout: 4000})
          return;
        } 

        getDataFromServer('remove_menu', {menu_id: this.selectedMenu})
        .then(obj => 
        {                  
          if(obj.data.success === true){
            this.getMenuList()
          }
          else{
            this.flash('remove menu error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {          
           this.flash('remove menu error: ' + err, 'error', {timeout: 4000})
        })
      },

      moveMenuItemUp(e, position, direction){ 
        console.log("input moveMenuItemUp: ", position, direction);       
        let elMove = null, elMoveIndex, elMoveIndexTo;
        for(let i=0; i < this.menuItems.length; i++){          
          if(this.menuItems[i].position === position){
            elMove = this.menuItems[i];
            elMoveIndex = i;
          }
        }        
        elMoveIndexTo = direction === 'up' ? parseInt(position) - 1 : parseInt(position) + 1;
        console.log("elMoveIndexTo: ", elMoveIndexTo)
        if(elMoveIndexTo >= 0){
           this.menuItems.splice(elMoveIndex, 1);
           this.menuItems.splice(elMoveIndexTo, 0, elMove);        
           this.orderPositions();
        }       
      },     

      orderPositions(){
        let mItems = [];
        for(let i = 0; i< this.menuItems.length; i++){
          this.menuItems[i].position = i 
          mItems.push(this.menuItems[i])
        }
        this.menuItems = mItems

        let menu = {};

        for(let m = 0; m < this.menuList.length; m++){
          if(this.menuList[m]._id === this.selectedMenu){
            this.menuList[m].menu_items = mItems
            menu = this.menuList[m];
          }
        }
        console.log("update menu posi: ", menu)
        getDataFromServer('update_menu', menu)
        .then(obj => 
        {                  
          if(obj.data.success === true){
            this.getMenuList()
          }
          else{
            this.flash('update menu items error: ' + obj.data.text , 'error', {timeout: 4000})
          }          
        })
        .catch(err => {          
           this.flash('update menu items error: ' + err, 'error', {timeout: 4000})
        })
      }
    },
    created(){        
        getDataFromServer('get_configuration', null)
        .then(obj => 
        {          
          if(obj.data.success === true){            
            //init language
            var languageObj = {
              name: 'language', 
              label: 'Language',
              selected: obj.data.data.language,
              onSelectCB: this.changeLanguage, 
              }
            this.$store.dispatch('INIT_LANGUAGE_ENTITY', languageObj)
            this.language = obj.data.data.language
            this.getMenuList()  
          }
          else{
            this.flash('get default language error: ' + obj.data.text , 'error', {timeout: 4500})
          }          
        })
        .catch(err => {          
           this.flash('get default language error: ' + err, 'error', {timeout: 4500})
        })    
    },
  }
</script>

<style scoped>
  .menu-item-ul{
    margin-top: 30px;
  }
  .menu-item-li{
    display: flex;
    justify-content: space-between;
  }

  .menu-item-li span{
    margin-top: 12px;
  }  

  .button-icon{
    margin-top: 5px;
    font-size: 24px;
    cursor: pointer;
    color: #757575;
  }

  .button-icon:hover{
    opacity: 0.8; 
  }

  #btnRemoveMenu,
  #btnAddMenu{
    margin-top: 23px;
  }

  .btn-admin-menu-up-down{
    padding: unset;
  }

  .div-admin-menu-up-down-container{
    padding-top: 8px;
    margin-right: 10px;
  }
</style>
